import './_style.scss';

import React from 'react';
import { Modal, ModalBody, ModalHeader} from 'reactstrap';

const ModalExclusaoSucesso = ({ isOpen, toggle, numeroContrato }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal_md">
      <ModalHeader toggle={toggle}>Exclusão de Protocolo</ModalHeader>
      <ModalBody>
        <label className="label_success">
          Contrato {numeroContrato}
          {' '}
          excluído com sucesso
          </label>
      </ModalBody>
    </Modal>
  );
}

export default ModalExclusaoSucesso;
